import {useState,useEffect} from "react";

import { Form } from "react-bootstrap";
import { showErrorInput } from "../../../../utils/helperFunctions";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import Select from "react-select";

import { BsPlus,BsTrash } from "react-icons/bs";
import useAxios from "../../../../services/useAxios.tsx";

export default function WareHousing({factorList,setFactorList,product_id}){
    const {execute:getFactorApi }= useAxios("factor/get_factor");
    const {execute : validateFactorApi} = useAxios("api3/validation_factor");
    const {execute : deleteLinkFactorApi} = useAxios("api3/delete_link_factor_product");
    
    const [factors,setFactors] =useState([]);

    const [values, setValues] = useState({
        factors:{},
        factorItem:{},
        count:"",
      });

      const schema = yup.object({
        factors:yup.mixed().test("factors","یک فاکتور را انتخاب نمایید",(value)=>{
            if (value?.value == undefined) return false;
            return true;
        }),
        factorItem:yup.mixed().test("factorItem","آیتم فاکتور را انتخاب نمایید",(value)=>{
            if (value?.value == undefined) return false;
            return true;
        }),
        count:yup.string().required("تعداد را وارد نمایید."),
        });
      const formController = useForm({
        resolver: yupResolver(schema),
        // values: { ...values },
        defaultValues: values,
        resetOptions: {
          // keepValues: true,
          // keepDirtyValues: false,
          keepErrors: true,
        },
      });
      useEffect(()=>{
        getFactorApi().then(data=>{
          setFactors(data?.data?.map(v=>({
            // ...v,
            label:v.store_title,
            value:v.id,
            items:v.items?.map(v=>({
              ...v.items,
              // label:v?.title + " ("+ v?.count + "عدد)" ,
              label:"شناسه " + v?.id + " - " + v?.title + " ("+ v?.count + "عدد)"  ,
              value:v?.id,
              title:v?.title
            }))
          })));
        })
      },[]);
    const onSubmit = data => {
      console.log("data",data);
        validateFactorApi({factor_item_id:data?.factorItem?.value ,inventory:data?.count}).then(result=>{
            if (result?.data?.bigger_status != "1"){
            let obj={
              count:data?.count,
              factor_item_id:data?.factorItem?.value,
              factor_id:data?.factors?.value,
              factor_item_title:data?.factorItem?.title,
              factor_name:data?.factors?.label,
              type:"0",
              index:factorList.length
            }
            factorList.push(obj);
            formController.reset();
            toast.success(`با موفقیت موجودی اضافه شد . تعداد ${result?.data?.difference} از این آیتم فاکتور باقی مانده است`);
            }else{
                  toast.error(`تعداد محصولات از فاکتور ثبت شده بیشتر است تعداد ${result?.data?.difference} از این ایتم فاکتور برای تعریف محصول در دسترس است.
                  `)
                }
        })
        }
        // console.log("factor list",factorList)
    const deleteFactor = (data) => {
      {data?.type == "1"?
      Swal.fire({
        title: "آیا از حذف این فاکتور مطمئن هستید؟",
        showDenyButton: true,
        confirmButtonColor: "rgb(25,135,84)",
        confirmButtonText: "بله",
        denyButtonText: `خیر`
      }).then(({ isConfirmed }) => {
        if (isConfirmed){
      deleteLinkFactorApi({product_id:product_id,factor_product_link_id:data?.id}).then(result=>{
        if(result.status == 1){
          setFactorList(factorList.filter(v=>v?.id != data?.id));
          toast.success("فاکتور مورد نظر حذف شد");
        }else{
          toast.error(result?.msg)
        }
      })

        }
      })
      :
      setFactorList(factorList.filter(v=>v.index != data?.index))
    }
    }
    return(
        <>
        <div className="m-4">
        <Form 
        // onSubmit={formController.handleSubmit(onSubmit)}
        id="ware_form" 
        >
        <div className="d-flex align-items-center w-100 flex-wrap p-3 shadow-04 rd-10">
            <div className="pd-x-6 mr-b-12 w-50"style={{minWidth:300}}>
                <Form.Group>
                    <Form.Label>فاکتور</Form.Label>
              <Controller
                control={formController.control}
                name="factors"
                render={({ field: { value, onChange } }) => (
                  <Select
                  options={factors}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    placeholder="فاکتور خرید را انتخاب نمایید"
                    className="shadow-none he-40 rd-8 "
                    // isInvalid={formController.formState.errors.factors}
                  />
                )}
              />
                </Form.Group>
                {formController.formState?.errors?.factors && (
                <p className="font-12-500 color-rd-01 mr-t-4 mr-r-8">
                  {formController.formState?.errors?.factors?.message}
                </p>
              )}
              {/* {showErrorInput(formController.formState.errors, "factors")} */}
            </div>
            <div className="pd-x-6 mr-b-12 w-50" style={{minWidth:300}}>
            <Form.Group>
                    <Form.Label>آیتم های فاکتور</Form.Label>
              <Controller
                control={formController.control}
                name="factorItem"
                render={({ field: { value, onChange } }) => (
                  <Select
                  options={formController.watch("factors")?.items}
                  
                  // isDisabled={formController.watch("factors").items?.length == 0}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    placeholder="آیتم های فاکتور"
                    className="shadow-none he-40 rd-8 "
                    
                  />
                )}
              />
              {formController.formState?.errors?.factorItem && (
                <p className="font-12-500 color-rd-01 mr-t-4 mr-r-8">
                  {formController.formState?.errors?.factorItem?.message}
                </p>
              )}
                </Form.Group>
              {/* {showErrorInput(formController.formState.errors, "factorItem")} */}
            </div>
            <div className="pd-x-6 mr-b-12 w-50"style={{minWidth:300}}>
                <Form.Group>
                    <Form.Label>تعداد</Form.Label>
                    <Controller
                        name="count"
                        control={formController.control}
                        render={({field:{value,onChange}})=>(
                            <Form.Control
                            className="shadow-none he-40 rd-8"
                                value={value}
                                onChange={(e)=>{
                                    if(!isNaN(e.target.value)){
                                        onChange(e.target.value);
                                    }
                                }}
                            />
                        )}
                    />
              {formController.formState?.errors?.count && (
                <p className="font-12-500 color-rd-01 mr-t-4 mr-r-8">
                  {formController.formState?.errors?.count?.message}
                </p>
              )}
                </Form.Group>
            </div>
            <div className="w-50 text-end">
                <button className="bg-bl-11 rd-6 btn"
                 form="ware_form" 
                 type="submit"
                onClick={formController.handleSubmit(onSubmit)}
                >
                    <BsPlus className="text-white wh-24" />
                </button>
            </div>
          </div>
          </Form>

          <div>
            {factorList?.map(value=>(
                      <div className="d-flex flex-wrap rd-10 mr-x-30 mr-t-20 bg-bl-05">
                      <div className="flex-grow-1">
                          <div className="text-center text-secondary pd-8 border border-white font-14-700">نام فاکتور</div>
                          <div className="text-center text-secondary pd-8 border border-white font-14-500">{value?.factor_name}</div>
                      </div>
                      <div className="flex-grow-1">
                          <div className="text-center text-secondary pd-8 border border-white font-14-700">شناسه آیتم فاکتور</div>
                          <div className="text-center text-secondary pd-8 border border-white font-14-500">
                              {value?.factor_item_id}
                          </div>
                      </div>
                      <div className="flex-grow-1">
                          <div className="text-center text-secondary pd-8 border border-white font-14-700">نام آیتم فاکتور</div>
                          <div className="text-center text-secondary pd-8 border border-white font-14-500">
                              {value?.factor_item_title}
                          </div>
                      </div>
                      <div className="flex-grow-1">
                          <div className="text-center text-secondary pd-8 border border-white font-14-700">تعداد</div>
                          <div className="text-center text-secondary pd-8 border border-white font-14-500">
                              {value?.count}
                              </div>
                      </div>

                      <div className="flex-grow-1">
                          <div className="text-center text-secondary pd-8 border border-white font-14-700">عملیات</div>
                          <div className="text-center text-secondary pd-8 border border-white he-40 ">                              
                              <div className="h-100 pointer" 
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content="حذف"
                              onClick={()=>{deleteFactor(value)}}>
                                  <BsTrash className="text-danger wh-20" />
                              </div>
                              
                          </div>
                      </div>
                  </div>
            ))}
          </div>
        </div>
        </>
    )
}